// extracted by mini-css-extract-plugin
export var borderRadius = "_a2-4";
export var large = "_a2-3";
export var logoContainer = "_a2-0";
export var nameLogo = "_a2-2";
export var small = "_a2-1";